export default class EmrState {}
